import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

export const useExternalBrowser = () => {
  const openUrl = async (url: string) => {
    console.log('[useExternalBrowser] Opening URL:', url);
    console.log('[useExternalBrowser] Is native platform:', Capacitor.isNativePlatform());
    
    try {
      if (Capacitor.isNativePlatform()) {
        // Use Capacitor Browser for native apps
        console.log('[useExternalBrowser] Using Capacitor Browser');
        await Browser.open({ url });
        console.log('[useExternalBrowser] Browser.open completed');
      } else {
        // Use window.open for web
        console.log('[useExternalBrowser] Using window.open');
        window.open(url, '_blank');
      }
    } catch (error) {
      console.error('[useExternalBrowser] Error opening URL:', error);
      // Fallback to window.location for iOS if Browser fails
      window.location.href = url;
    }
  };

  return { openUrl };
};
